import { render, staticRenderFns } from "./MarqetaDisplayCardLegacy.vue?vue&type=template&id=1bcd7ee8&scoped=true"
import script from "./MarqetaDisplayCardLegacy.vue?vue&type=script&lang=js"
export * from "./MarqetaDisplayCardLegacy.vue?vue&type=script&lang=js"
import style0 from "./MarqetaDisplayCardLegacy.vue?vue&type=style&index=0&id=1bcd7ee8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bcd7ee8",
  null
  
)

export default component.exports